import { useQuery } from "@apollo/client";
import { LIST_TRIP_FLIGHT_SUMMARY } from "../graphQl/DetailsTripAPI";

export const useDetailsTrip = (tripPublicationId) => {
  const { loading, error, data } = useQuery(LIST_TRIP_FLIGHT_SUMMARY, {
    variables: { tripPublicationId },
    skip: !tripPublicationId,
  });

  const tripFlight = data?.QR_LIST_TRIP_FLIGHT_SUMMARY?.data;

  return {
    loading,
    error,
    tripFlight,
  };
};
